// BIGLI-110：LINE 新需求未讀數。每 60 秒查一次、切回分頁（window focus）立即查、
// 收到 requestLineUnreadRefresh() 也立即查；不用 WebSocket。查詢失敗保留上一次的數字。
import { useCallback, useEffect, useState } from 'react';
import { getLineUnreadCount } from '../services/lineApi';
import { LINE_UNREAD_POLL_MS, LINE_UNREAD_REFRESH_EVENT } from '../utils/lineUnread';

const EMPTY = { total: 0, byStore: {} };

const useLineUnreadCount = (enabled = true) => {
  const [counts, setCounts] = useState(EMPTY);

  const refresh = useCallback(async () => {
    try {
      const data = await getLineUnreadCount();
      setCounts({ total: Number(data?.total) || 0, byStore: data?.byStore || {} });
    } catch (e) {
      // 網路暫時失敗不清掉紅點，等下一輪
    }
  }, []);

  useEffect(() => {
    if (!enabled) {
      setCounts(EMPTY);
      return undefined;
    }
    refresh();
    const timer = setInterval(refresh, LINE_UNREAD_POLL_MS);
    window.addEventListener('focus', refresh);
    window.addEventListener(LINE_UNREAD_REFRESH_EVENT, refresh);
    return () => {
      clearInterval(timer);
      window.removeEventListener('focus', refresh);
      window.removeEventListener(LINE_UNREAD_REFRESH_EVENT, refresh);
    };
  }, [enabled, refresh]);

  return { counts, refresh };
};

export default useLineUnreadCount;
